import { Injectable } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReceivingRequestSummaryService {

  constructor(private httpService: HttpService) { }
    getDataforAdvancedFilter(params: any): Observable<any> {
      return this.httpService.post('receiving-request-summary', params);
    }
    getReceivingRequestSummary(params: any): Observable<any> {
      return this.httpService.post('receiving-request-summary', params);
    }
}
